import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Emergency, Info, VSubstanceUseDisorderIcon } from 'shared/assets/icons';
import { Spinner, SUDStatusKind, useDisclosure } from 'shared/components';
import { useSUDPowerPanel } from './SUDPowerPanel';
import { ReferToSUDModal } from './ReferToSUDModal';
import { StatusCard } from './StatusCard';
import { DismissSUDNotificationModal, } from 'shared/features/substance-use-disorder/components/DismissSUDNotificationModal';
import { SUDScheduleModal } from 'shared/features/substance-use-disorder/components/SUDScheduleModal';
import { useSUDProgram } from 'shared/hooks/useSUDProgram';
import { useDismissNotification } from 'shared/features/substance-use-disorder/hooks/useDismissNotification';
var getItemsFromStatus = function (status) {
    switch (status) {
        case SUDStatusKind.Flagged:
            return {
                statusText: 'Review for SUD program',
                statusTextColor: 'warning-on-subtle',
                bgColor: 'warning-subtle',
                icon: Emergency,
            };
        case SUDStatusKind.HasAccess:
            return {
                statusText: 'Access to SUD program',
                statusTextColor: 'info.text',
                bgColor: 'info.light',
                icon: Info,
            };
        case SUDStatusKind.ReferredByProvider:
            return {
                statusText: 'Referred to SUD program',
                statusTextColor: 'success.text',
                bgColor: 'success.light',
                icon: VSubstanceUseDisorderIcon,
            };
        case SUDStatusKind.Enrolled:
            return {
                statusText: 'Enrolled in SUD program',
                statusTextColor: 'success.text',
                bgColor: 'success.light',
                icon: VSubstanceUseDisorderIcon,
            };
    }
};
var SUDStatus = function (_a) {
    var _b;
    var member = _a.member, sudProgram = _a.sudProgram, scheduleWithSUDModalDisclosure = _a.scheduleWithSUDModalDisclosure, _c = _a.showAnyways, showAnyways = _c === void 0 ? false : _c;
    var _d = useDismissNotification(member.id, sudProgram.status), isNotificationDismissed = _d.isNotificationDismissed, dismissNotification = _d.dismissNotification;
    var _e = getItemsFromStatus(sudProgram.status), statusText = _e.statusText, statusTextColor = _e.statusTextColor, bgColor = _e.bgColor, icon = _e.icon;
    var referToSUDModalDisclosure = useDisclosure();
    var dismissSUDNotificationDisclosure = useDisclosure();
    var sudPowerPanel = useSUDPowerPanel({
        sudStatus: sudProgram.status,
        memberName: member.first_name,
        referToSUDModalDisclosure: referToSUDModalDisclosure,
        scheduleWithSUDModalDisclosure: scheduleWithSUDModalDisclosure,
        dismissSUDNotificationDisclosure: dismissSUDNotificationDisclosure,
        statusTextColor: statusTextColor,
        statusBgColor: bgColor,
        showDismissButton: !isNotificationDismissed,
    });
    var togglePowerPanel = function () {
        if (sudPowerPanel.isOpen) {
            sudPowerPanel.close();
        }
        else {
            sudPowerPanel.open();
        }
    };
    if (!showAnyways && isNotificationDismissed) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(SUDScheduleModal, { memberFullName: "".concat(member.first_name, " ").concat(member.last_name), disclosure: scheduleWithSUDModalDisclosure, schedulingURL: (_b = sudProgram === null || sudProgram === void 0 ? void 0 : sudProgram.care_navigator) === null || _b === void 0 ? void 0 : _b.scheduling_url }), _jsx(ReferToSUDModal, { disclosure: referToSUDModalDisclosure, scheduleWithSUDModalDisclosure: scheduleWithSUDModalDisclosure, sudPowerPanelDisclosure: sudPowerPanel, memberFirstName: member.first_name, memberFullName: "".concat(member.first_name, " ").concat(member.last_name), memberId: member.id }), _jsx(DismissSUDNotificationModal, { dismissNotification: dismissNotification, sudPowerPanelDisclosure: sudPowerPanel, disclosure: dismissSUDNotificationDisclosure }), _jsx(StatusCard, { statusText: statusText, statusTextColor: statusTextColor, bgColor: bgColor, icon: icon, onClickCta: sudProgram.status !== SUDStatusKind.Enrolled ? togglePowerPanel : null, clickedState: sudPowerPanel.isOpen })] }));
};
var SUDStatusWrapper = function (_a) {
    var member = _a.member, showAnyways = _a.showAnyways;
    var _b = useSUDProgram(member.id), sudProgram = _b.data, isFetching = _b.isFetching;
    // This disclosure is outside <SUDStatus /> because it should persist across remounts
    var scheduleWithSUDModalDisclosure = useDisclosure();
    if (isFetching) {
        return _jsx(Spinner, {});
    }
    if (!sudProgram) {
        return _jsx(_Fragment, {});
    }
    return _jsx(SUDStatus, { member: member, sudProgram: sudProgram, showAnyways: showAnyways, scheduleWithSUDModalDisclosure: scheduleWithSUDModalDisclosure });
};
export { SUDStatusWrapper as SUDStatus };
